



























import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class GoogleRecaptchaV3 extends Vue {
  // Props
  @Prop({ default: "" })
  public value!: string;
  // Props
  @Prop({ required: true })
  public action!: string;
  // Data
  public grecaptcha: any = window["grecaptcha"] || undefined;
  public siteKey = process.env.VUE_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY;
  public $refs!: {
    grv3: HTMLScriptElement;
  };

  public created() {
    if (this.grecaptcha) this.generateToken();
  }

  public mounted() {
    if (this.grecaptcha) return;
    const script = document.createElement("script");
    const src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
    script.setAttribute("src", src);
    document.head.appendChild(script);
    script.addEventListener("load", () => {
      window["grecaptcha"].ready(() => {
        this.grecaptcha = window["grecaptcha"];
        this.generateToken();
      });
    });
  }

  public async generateToken() {
    if (!this.grecaptcha) return;
    const token = await this.grecaptcha.execute(this.siteKey, {
      action: this.action
    });
    this.$emit("input", token);
  }
}
